import { FormattedMessage } from 'react-intl';
import * as Yup from 'yup';

export const resetPasswordValidation = Yup.object().shape({
  password: Yup.string()
    .required(<FormattedMessage id="security.update-password-required" />)
    .min(8, <FormattedMessage id="security.password-length" />),
  confirm_password: Yup.string()
    .oneOf([Yup.ref('password'), null], <FormattedMessage id="security.confirm-password-match" />)
    .required(<FormattedMessage id="security.confirm-update-password-required" />)
});

export const resetPinValidation = Yup.object().shape({
  new_pin: Yup.string()
    .required(<FormattedMessage id="security.update-pin-required" />)
    .min(4, <FormattedMessage id="security.pin-length" />),
  confirm_pin: Yup.string()
    .oneOf([Yup.ref('new_pin'), null], <FormattedMessage id="security.confirm-pin-match" />)
    .required(<FormattedMessage id="security.confirm-update-pin-required" />)
});
